import Vue from 'vue';
import Router from 'vue-router';
import RouterConfig from './modules';
import store from '../store';

const login = () => import('@/components/login/login');
const wxAuth = () => import('@/components/home/wxAuth');
const wxAuthorizationPage = () => import('@/components/login/wxAuthorizationPage');
const home = () => import('@/components/home/home'); /* 主页 */
const allApplications = () => import('@/components/home/allApplications');
const todayReport = () => import('@/components/menuList/list/todayReport'); /** 今日报表 */
const monthReport = () => import('@/components/menuList/list/monthReport'); /** 运营报表 */
const salesDetails = () => import('@/components/menuList/list/salesDetails'); /** 销售细节 */
const aisleConfig = () => import('@/components/menuList/list/aisleConfig'); /** 货道配置 */
const aisleDetails = () => import('@/components/menuList/list/aisleDetails'); /** 货道细节 */
const setLocation = () => import('@/components/menuList/list/setLocation'); /** 修改地址 */
const changeGoods = () => import('@/components/menuList/list/changeGoods'); /** 货道的更改商品 */
const machineDetails = () => import('@/components/menuList/list/machineDetails'); /** 设备详情 */
const machineCode = () => import('@/components/menuList/list/machineCode'); /** 机器二维码 */
const machineTemperature = () => import('@/components/menuList/list/machineTemperature'); /** 设置温度 */
const machineBusinessHours = () => import('@/components/menuList/list/machineBusinessHours'); /** 定时营业 */
const paymentDetails = () => import('@/components/menuList/list/paymentDetails'); /** 收支详情 */
const changeMachineInfo = () => import('@/components/menuList/list/changeMachineInfo'); /** 修改或添加设备 */
const replenishment = () => import('@/pages/replenishment/replenishment'); /** 补货主页 */
const replenishmentDetails = () => import('@/pages/replenishment/replenishmentDetails'); /** 补货详细内容 */
const dataAnalysis = () => import('@/components/menuList/list/dataAnalysis'); /** 数据分析主页 */
const salesStatistics = () => import('@/components/menuList/list/salesStatistics'); /** 销售统计主页 */
const incomeStatistics = () => import('@/components/menuList/list/incomeStatistics'); /** 在线收入统计主页 */
const incomeStat = () => import('@/pages/user/incomeStat'); /** 账号在线支付收入概览 */
const salesStatisticsDetails = () => import('@/components/menuList/list/salesStatisticsDetails'); /** 销售统计详情页 */
const noncash = () => import('@/components/menuList/list/noncash'); /** 非现金售货机主页 */
const machineCopy = () => import('@/components/menuList/list/machineCopy'); /** 设备复制 */
const allocation = () => import('@/components/menuList/list/allocation'); /** 分配 */
const activityOrder = () => import('@/components/menuList/list/activityOrder'); /** 活动订单 */
const breakMachine = () => import('@/components/menuList/list/breakMachine'); /** 售货机故障主页 */
const breakMissingDetails = () => import('@/components/menuList/list/breakMissingDetails'); /** 失联详情 */
const breakStockoutDetails = () => import('@/components/menuList/list/breakStockoutDetails'); /** 缺货详情 */
const breakAisleFaultDetails = () => import('@/components/menuList/list/breakAisleFaultDetails'); /** 故障详情 */

const setting = () => import('@/components/setting/setting'); /** 设置主页 */
const renew = () => import('@/components/setting/renew'); /** 设备续费 */
const renewConfirm = () => import('@/components/setting/renewConfirm'); /** 确认续费 */
const renewBlank = () => import('@/components/setting/renewBlank'); /** 续费跳转页 */
const changePassword = () => import('@/components/setting/changePassword'); /** 修改密码 */
const resetPassword = () => import('@/pages/user/resetPassword'); /** 重置密码 */
const refundSetting = () => import('@/components/setting/refundSetting'); /** 退款设置 */

const service = () => import('@/components/setting/feedback/service'); /** 客服管理 */
const reple = () => import('@/components/setting/feedback/body'); /** 合集 */

const goodsList = () => import('@/components/menuList/list/goodsList'); /** 商品列表 */
const goodsClassify = () => import('@/components/menuList/list/goodsClassify'); /** 商品分类 */
const addGoods = () => import('@/components/menuList/list/addGoods'); /** 添加商品 */
const selectPlatGoods = () => import('@/components/menuList/list/selectPlatGoods'); /** 从平台商品库新建 */
const selectPlatGoodsOperator = () => import('@/components/menuList/list/selectPlatGoodsOperator'); /** 从平台商品库批量选择 */
const changeAlreadyGoods = () => import('@/components/menuList/list/changeAlreadyGoods'); /** 修改商品 */
const copyGoods = () => import('@/components/menuList/list/copyGoods'); /** 复制商品 */

const vip = () => import('@/components/menuList/vip/vip'); /** 会员卡首页 */
const vipDetails = () => import('@/components/menuList/vip/vipDetails'); /** 会员卡详情 */
const cardReissue = () => import('@/components/menuList/vip/cardReissue'); /** 补卡 */
const recharge = () => import('@/components/menuList/vip/recharge'); /** 充值 */
const addVip = () => import('@/components/menuList/vip/addVip'); /** 充值 */

const not404 = () => import('@/components/notFound/404');
const not505 = () => import('@/components/notFound/505');

// 二级路由
const breakMissing = () => import('@/components/menuList/list/breakMissing'); /** 失联 */
const breakStockout = () => import('@/components/menuList/list/breakStockout'); /** 缺货 */
const breakAisleFault = () => import('@/components/menuList/list/breakAisleFault'); /** 货道故障 */

// page目录
const goodsBaseList = () => import('@/pages/goodsBaseList/goodsBaseList');
const pickUpCode = () => import('@/pages/pickUpCode/pickUpCode');
const addPickUpCode = () => import('@/pages/pickUpCode/addPickUpCode');
const salesProfit = () => import('@/pages/salesProfit/salesProfit');
const replenishList = () => import('@/pages/replenishRecord/list');
const replenishDetail = () => import('@/pages/replenishRecord/detail');
const noCashList = () => import('@/pages/orderList/noCashList');
const noCashDetail = () => import('@/pages/orderList/noCashDetail');
const machineReplenish = () => import('@/pages/machineReplenish/machineReplenish');
const searchReplenish = () => import('@/pages/machineReplenish/searchReplenish');
const replenishOrder = () => import('@/pages/machineReplenish/replenishOrder');
const replenishOrderList = () => import('@/pages/machineReplenish/replenishOrderList');
const replenishOrderDetail = () => import('@/pages/machineReplenish/replenishOrderDetail');
// 风控警示详情页
const riskControlDetail = () => import('@/pages/riskContrl/riskControlDetail');
const riskGuide = () => import('@/pages/riskContrl/riskGuide');
const walletIncomeTotal = () => import('@/pages/riskContrl/walletIncomeTotal');
const arrivalDetail = () => import('@/pages/riskContrl/arrivalDetail');

// 测试页面
const testPage = () => import('@/pages/test/test');

const salesInventory = () => import('@/components/menuList/list/salesInventory');

const siteList = () => import('@/components/menuList/list/siteList');

const addSite = () => import('@/pages/site/addSite');

Vue.use(Router);

const routes = [
  {
    path: '/', redirect: '/home', component: home, meta: { title: '首页', noNavBar: true },
  },
  {
    path: '/home', name: 'home', component: home, meta: { title: '首页', noNavBar: true },
  },
  {
    path: '/applications', name: 'allApplications', component: allApplications, meta: { title: '全部应用' },
  },
  {
    path: '/wxAuth', name: 'wxAuth', component: wxAuth, meta: { noNavBar: true },
  },
  {
    path: '/incomeStat', name: 'incomeStat', component: incomeStat, meta: { title: '收入概览' },
  },
  {
    path: '/testPage', name: 'testPage', component: testPage, meta: { title: '测试' },
  },
  {
    path: '/goodsBaseList', name: 'goodsBaseList', component: goodsBaseList, meta: { title: '商品库' },
  },
  {
    path: '/menuList', name: 'menuList', redirect: { name: 'allApplications' }, meta: { title: '全部应用' },
  },
  {
    path: '/todayReport', name: 'todayReport', component: todayReport, meta: { title: '今日报表' },
  },
  {
    path: '/monthReport', name: 'monthReport', component: monthReport, meta: { title: '运营报表' },
  },
  {
    path: '/salesDetails', name: 'salesDetails', component: salesDetails, meta: { title: '全部分类' },
  },
  {
    path: '/deliveryRecord', name: 'deliveryRecord', redirect: to => ({ name: 'noCashList', query: { ...to.query, tab: 'delivery' } }), meta: { title: '出货明细' },
  },
  {
    path: '/aisleConfig', name: 'aisleConfig', component: aisleConfig, meta: { title: '货道管理' },
  },
  {
    path: '/aisleDetails', name: 'aisleDetails', component: aisleDetails, meta: { title: '货道管理' },
  },
  {
    path: '/changeGoods', name: 'changeGoods', component: changeGoods, meta: { title: '更改商品' },
  },
  {
    path: '/machineDetails', name: 'machineDetails', component: machineDetails, meta: { title: '设备详情' },
  },
  {
    path: '/setLocation', name: 'setLocation', component: setLocation, meta: { title: '设备地址' },
  },
  {
    path: '/paymentDetails', name: 'paymentDetails', component: paymentDetails, meta: { title: '收支详情' },
  },
  {
    path: '/changeMachineInfo', name: 'changeMachineInfo', component: changeMachineInfo, meta: { title: '设备详情' },
  },
  {
    path: '/machineCode', name: 'machineCode', component: machineCode, meta: { title: '机器二维码' },
  },
  {
    path: '/machineTemperature', name: 'machineTemperature', component: machineTemperature, meta: { title: '机器设置' },
  },
  {
    path: '/machineBusinessHours', name: 'machineBusinessHours', component: machineBusinessHours, meta: { title: '定时营业' },
  },
  {
    path: '/replenishment', name: 'replenishment', component: replenishment, meta: { title: '设备补货' },
  },
  {
    path: '/replenishmentDetails', name: 'replenishmentDetails', component: replenishmentDetails, meta: { title: '设备补货' },
  },
  {
    path: '/dataAnalysis', name: 'dataAnalysis', component: dataAnalysis, meta: { title: '数据分析' },
  },
  {
    path: '/salesStatistics', name: 'salesStatistics', component: salesStatistics, meta: { title: '销售统计' },
  },
  {
    path: '/salesInventory', name: 'salesInventory', component: salesInventory, meta: { title: '销售库存' },
  },
  {
    path: '/incomeStatistics', name: 'incomeStatistics', component: incomeStatistics, meta: { title: '在线收入统计' },
  },
  {
    path: '/salesStatisticsDetails', name: 'salesStatisticsDetails', component: salesStatisticsDetails, meta: { title: '销售统计' },
  },
  {
    path: '/siteList', name: 'siteList', component: siteList, meta: { title: '点位列表' },
  },
  {
    path: '/addSite', name: 'addSite', component: addSite, meta: { title: '新建点位' },
  },
  {
    path: '/siteRelationMachine', name: 'siteRelationMachine', component: () => import('@/pages/site/siteRelationMachine'), meta: { title: '关联设备' },
  },
  {
    path: '/noncash', name: 'noncash', component: noncash, meta: { title: '售货机', noNavBar: true },
  },
  {
    path: '/machineCopy', name: 'machineCopy', component: machineCopy, meta: { title: '复制机器' },
  },
  {
    path: '/allocation', name: 'allocation', component: allocation, meta: { title: '分配机器', noNavBar: true },
  },
  {
    path: '/cashMachine', name: 'cashMachine', redirect: { name: 'noCashList' }, meta: { title: '设备订单' },
  },
  {
    path: '/activityOrder', name: 'activityOrder', component: activityOrder, meta: { title: '活动订单' },
  },
  {
    path: '/breakMachine',
    name: 'breakMachine',
    redirect: '/breakMachine/breakMissing',
    component: breakMachine,
    meta: { title: '售货机' },
    children: [
      {
        path: '/breakMachine/breakMissing',
        name: 'breakMissing',
        component: breakMissing,
        meta: { title: '失联' },
      },
      {
        path: '/breakMachine/breakAisleFault',
        name: 'breakAisleFault',
        component: breakAisleFault,
        meta: { title: '货道故障' },
      },
      {
        path: '/breakMachine/breakStockout',
        name: 'breakStockout',
        component: breakStockout,
        meta: { title: '缺货' },
      },
    ],
  },
  {
    path: '/breakMissingDetails',
    name: 'breakMissingDetails',
    component: breakMissingDetails,
    meta: { title: '失联详情' },
  },
  {
    path: '/breakStockoutDetails',
    name: 'breakStockoutDetails',
    component: breakStockoutDetails,
    meta: { title: '缺货详情' },
  },
  {
    path: '/breakAisleFaultDetails',
    name: 'breakAisleFaultDetails',
    component: breakAisleFaultDetails,
    meta: { title: '故障详情' },
  },
  {
    path: '/goodsList', name: 'goodsList', component: goodsList, meta: { title: '商品列表' },
  },
  {
    path: '/goodsClassify', name: 'goodsClassify', component: goodsClassify, meta: { title: '商品分类' },
  },
  {
    path: '/addGoods', name: 'addGoods', component: addGoods, meta: { title: '新建商品' },
  },
  {
    path: '/selectPlatGoods', name: 'selectPlatGoods', component: selectPlatGoods, meta: { title: '商品库' },
  },
  {
    path: '/selectPlatGoodsOperator', name: 'selectPlatGoodsOperator', component: selectPlatGoodsOperator, meta: { title: '商品批量选择' },
  },
  {
    path: '/changeAlreadyGoods', name: 'changeAlreadyGoods', component: changeAlreadyGoods, meta: { title: '修改商品' },
  },
  {
    path: '/copyGoods', name: 'copyGoods', component: copyGoods, meta: { title: '复制商品' },
  },
  {
    path: '/setting', name: 'setting', component: setting, meta: { title: '我的', noNavBar: true },
  },
  {
    path: '/refundSetting', name: 'refundSetting', component: refundSetting, meta: { title: '退款设置' },
  },
  {
    path: '/requestWithdrawal', name: 'requestWithdrawal', redirect: { name: 'setting' }, meta: { title: '我的' },
  },
  {
    path: '/renew', name: 'renew', component: renew, meta: { title: '设备续费' },
  },
  {
    path: '/renewConfirm', name: 'renewConfirm', component: renewConfirm, meta: { title: '续费支持' },
  },
  {
    path: '/pay/renewBlank', name: 'renewBlank', component: renewBlank, meta: { title: '续费支持' },
  },
  {
    path: '/feedback', name: 'feedback', redirect: { name: 'setting' }, meta: { title: '我的' },
  },
  {
    path: '/changePassword', name: 'changePassword', component: changePassword, meta: { title: '修改密码' },
  },
  {
    path: '/resetPassword', name: 'resetPassword', component: resetPassword, meta: { title: '重置密码' },
  },
  {
    path: '/withdrawDepositRecord', name: 'withdrawDepositRecord', redirect: { name: 'setting' }, meta: { title: '我的' },
  },
  {
    path: '/service', name: 'service', component: service, meta: { title: '客服管理' },
  },
  {
    path: '/reple', name: 'reple', component: reple, meta: { title: '客服管理' },
  },
  {
    path: '/vip', name: 'vip', component: vip, meta: { title: '会员卡' },
  },
  {
    path: '/vipDetails', name: 'vipDetails', component: vipDetails, meta: { title: '会员卡-详情' },
  },
  {
    path: '/cardReissue', name: 'cardReissue', component: cardReissue, meta: { title: '会员卡-补卡' },
  },
  {
    path: '/recharge', name: 'recharge', component: recharge, meta: { title: '会员卡-充值' },
  },
  {
    path: '/addVip', name: 'addVip', component: addVip, meta: { title: '会员卡-添加' },
  },
  {
    path: '/404', name: 'not404', component: not404, meta: { title: '404', noNavBar: true },
  },
  {
    path: '/505', name: 'not505', component: not505, meta: { title: '505', noNavBar: true },
  },
  {
    path: '/login', name: 'login', component: login, meta: { title: '登录', noNavBar: true },
  },
  {
    path: '/wxAuthorizationPage', name: 'wxAuthorizationPage', component: wxAuthorizationPage, meta: { title: '授权', noNavBar: true },
  },
  {
    path: '/riskControlDetail', name: 'riskControlDetail', component: riskControlDetail, meta: { title: '实名认证' },
  },
  {
    path: '/riskGuide', name: 'riskGuide', component: riskGuide, meta: { title: '操作指引' },
  },
  {
    path: '/walletIncomeTotal', name: 'walletIncomeTotal', component: walletIncomeTotal, meta: { title: '银行卡到账账单' },
  },
  {
    path: '/arrivalDetail', name: 'arrivalDetail', component: arrivalDetail, meta: { title: '账单信息' },
  },
  {
    path: '/pickUpCode', name: 'pickUpCode', component: pickUpCode, meta: { title: '提货码' },
  },
  {
    path: '/addPickUpCode', name: 'addPickUpCode', component: addPickUpCode, meta: { title: '添加提货码' },
  },
  {
    path: '/noCashList', name: 'noCashList', component: noCashList, meta: { title: '订单', noNavBar: true },
  },
  {
    path: '/noCashDetail', name: 'noCashDetail', component: noCashDetail, meta: { title: '订单详情' },
  },
  {
    path: '/salesProfit', name: 'salesProfit', component: salesProfit, meta: { title: '销售利润' },
  },
  {
    path: '/replenishList', name: 'replenishList', component: replenishList, meta: { title: '补货记录' },
  },
  {
    path: '/replenishDetail', name: 'replenishDetail', component: replenishDetail, meta: { title: '补货详情' },
  },
  {
    path: '/addIccard', name: 'addIccard', component: () => import('@/pages/iccard/addIccard'), meta: { title: '发卡' },
  },
  {
    path: '/iccardDetail', name: 'iccardDetail', component: () => import('@/pages/iccard/iccardDetail'), meta: { title: '会员卡明细' },
  },
  {
    path: '/systemRecord', name: 'systemRecord', component: () => import('@/pages/account/systemRecord'), meta: { title: '产品动态' },
  },
  {
    path: '/recodrDetail', name: 'recodrDetail', component: () => import('@/pages/account/recodrDetail'), meta: { title: '产品动态' },
  },
  {
    path: '/stat', name: 'stat', component: () => import('@/pages/stat/stat'), meta: { title: '报表', noNavBar: true },
  },
  {
    path: '/subsidiesDetailed', name: 'subsidiesDetailed', redirect: { name: 'setting' }, meta: { title: '我的' },
  },
  {
    path: '/machineReplenish',
    name: 'machineReplenish',
    component: machineReplenish,
    meta: {
      title: '缺货机器',
    },
  },
  {
    path: '/searchReplenish',
    name: 'searchReplenish',
    component: searchReplenish,
    meta: {
      title: '查询缺货',
    },
  },
  {
    path: '/replenishOrder',
    name: 'replenishOrder',
    component: replenishOrder,
    meta: {
      title: '缺货机器',
    },
  },
  {
    path: '/replenishOrderList',
    name: 'replenishOrderList',
    component: replenishOrderList,
    meta: {
      title: '设备补货单',
    },
  },
  {
    path: '/replenishOrderDetail',
    name: 'replenishOrderDetail',
    component: replenishOrderDetail,
    meta: {
      title: '补货单详情',
    },
  },
  { path: '*', redirect: '/' },
  ...RouterConfig,
];

const router = new Router({
  routes,
  mode: 'history',
  linkActiveClass: 'active', // 设置路由激活时的样式名
});

const originalPush = Router.prototype.push; /** 去除重名跳转报错 */
const originalReplace = Router.prototype.replace; /** 去除重名跳转报错 */

// push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

const noLoadName = ['login', 'menuList', 'breakMissing', 'breakStockout', 'breakAisleFault',
  'changePassword', 'not404', 'not505', 'service', 'wxAuth', 'bindingWxAccount', 'wxAuthorizationPage', 'wxAuthorizationMessage']; /** 不需要载入动画的页面名 */
const noCodeName = ['login', 'resetPassword', 'wxAuth', 'bindingWxAccount', 'wxAuthorizationPage', 'wxAuthorizationMessage'];

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title; /** 改变页面名字 */
  }

  if (noLoadName.indexOf(to.name) == -1) { /** 进入页面是  先出现加载动画 */
    store.dispatch('load/showGo', true);
  }

  store.dispatch('options/alertShowGo', { status: false }); /** 关闭所有下拉列表弹窗 */

  await store.dispatch('options/clearAllGo'); /** 清空已选择的内容 */

  if (noCodeName.includes(to.name)) {
    store.commit('auth/setMenusRouterCodeList', []);
    localStorage.removeItem('yjkjAccountInfo');
    next();
  } else if (store.state.auth.menusRouterCodeList.length === 0) {
    store.dispatch('auth/setAccountInfo').finally(() => {
      next();
    });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js